import { useTranslation } from "react-i18next";

const ServiceHero = () => {
  const { t } = useTranslation();
  return (
    <article className="relative h-[70vh] flex items-center justify-center">
      <div className="absolute w-full h-full">
        <img
          src="/assets/servicesHero.png"
          alt="servicesHero"
          className="object-cover w-full h-full"
        />
      </div>
      <div className="relative z-10 flex items-center justify-center w-full h-full bg-black/50">
        <section className="font-bold text-center text-white">
          <h1 className=" text-[20px] md:text-[80px] font-bold">{t("ourServices")}</h1>
          <p className="text-[16px] md:text-[24px] ">{t("discoverOurRange")}</p>
        </section>
      </div>
    </article>
  );
};

export default ServiceHero;
